"use client";

import { c as _c } from "react/compiler-runtime";
import { CDN_BASE } from "@/lib/image-url";
import { useEffect, useState } from "react";
import { CHARACTER_THEMES, type CharacterTheme } from "./ThemeToggle";
function currentCharacter(): CharacterTheme | null {
  const attr = document.documentElement.getAttribute("data-theme");
  return (CHARACTER_THEMES as readonly string[]).includes(attr ?? "") ? attr as CharacterTheme : null;
}

/** The SPIRE CODEX wordmark. In a character theme the character's icon
 * sits to the left of the words from the sm breakpoint up; phones get the
 * words alone. */
export default function Wordmark(t0) {
  const $ = _c(9);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [character, setCharacter] = useState(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setCharacter(currentCharacter());
      const observer = new MutationObserver(() => setCharacter(currentCharacter()));
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-theme"]
      });
      return () => observer.disconnect();
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== character) {
    t4 = character ? <img src={`${CDN_BASE}/ui/characters/character_icon_${character}.webp`} alt="" width={28} height={28} className="hidden sm:inline-block h-7 w-7 object-contain align-[-0.3em]" /> : null;
    $[2] = character;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const icon = t4;
  const t5 = `inline-flex items-center gap-2 text-xl font-bold ${className}`;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-[var(--accent-gold)]">SPIRE</span>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-[var(--text-primary)]">CODEX</span>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== icon || $[7] !== t5) {
    t8 = <span className={t5}>{icon}{t6}{" "}{t7}</span>;
    $[6] = icon;
    $[7] = t5;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}